import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DataService {
  constructor(public httpClient: HttpClient) {}

  get(APIPath: string): any {
    return this.httpClient.get(`${environment.apiEndPoint}${APIPath}`);
  }

  getWithParams(APIPath: string, params: HttpParams, options: any = {}): any {
    return this.httpClient.get(`${environment.apiEndPoint}${APIPath}`, {
       params, ...options 
    });
  }

  delete(APIPath: string, Key: any): any {
    return this.httpClient.delete(`${environment.apiEndPoint}${APIPath}${Key}`);
  }

  deleteWithParams(APIPath: string, params: HttpParams): any {
    return this.httpClient.delete(`${environment.apiEndPoint}${APIPath}`, {
      params,
    });
  }

  update(APIPath: string, OBJ: any): any {
    return this.httpClient.put(`${environment.apiEndPoint}${APIPath}`, OBJ);
  }

  post(APIPath: string, OBJ: any): any {
    return this.httpClient.post(`${environment.apiEndPoint}${APIPath}`, OBJ);
  }

  postWithParams(APIPath: string, OBJ: any, params: HttpParams): any {
    return this.httpClient.post(`${environment.apiEndPoint}${APIPath}`, OBJ, {
      params,
    });
  }
}
